<div class="flex flex-col gap-6">
  <!-- Loading State -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <p-progressSpinner
        strokeWidth="4"
        [style]="{ width: '50px', height: '50px' }">
      </p-progressSpinner>
    </div>
  }

  <!-- Error State -->
  @if (!loading && errorLoading) {
    <p-card>
      <div class="flex flex-col items-center gap-4 py-8">
        <i class="pi pi-exclamation-triangle text-4xl text-surface-500"></i>
        <p class="text-surface-500 dark:text-surface-400">{{ '2fa-status-error-message' | zDictionary }}</p>
      </div>
    </p-card>
  }

  <!-- 2FA Setup (when not enabled) -->
  @if (!loading && !errorLoading && !twoFactorEnabled) {
    <p-card>
      <ng-template pTemplate="header">
        <div class="px-4 pt-4">
          <div class="flex items-center gap-2">
            <i class="pi pi-shield text-primary"></i>
            <h3 class="text-lg font-semibold m-0">{{ '2fa-title' | zDictionary }}</h3>
          </div>
          <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">{{ '2fa-subtitle-disabled' | zDictionary }}</p>
        </div>
      </ng-template>
      <zaeper-two-factor-setup
        [setupDescription]="labels['2fa-setup-description'] || ''"
        [scanQrDescription]="labels['2fa-scan-qr-description'] || ''"
        [verifyDescription]="labels['2fa-verify-description'] || ''"
        [recoveryCodesTitle]="labels['2fa-recovery-codes-title'] || ''"
        [recoveryCodesDescription]="labels['2fa-recovery-codes-description'] || ''"
        [manualEntryLabel]="labels['2fa-manual-entry'] || ''"
        [beginSetupLabel]="labels['2fa-begin-setup'] || ''"
        [nextLabel]="labels['2fa-next'] || ''"
        [verifyLabel]="labels['2fa-verify'] || ''"
        [backToQrLabel]="labels['2fa-back-to-qr'] || ''"
        [doneLabel]="labels['2fa-done'] || ''"
        [copyLabel]="labels['2fa-copy'] || ''"
        [downloadLabel]="labels['2fa-download'] || ''"
        [copiedMessage]="labels['2fa-copied'] || ''"
        [requiredFieldMessage]="labels['2fa-required-field'] || ''"
        [invalidCodeMessage]="labels['2fa-invalid-code'] || ''"
        (setupComplete)="onSetupComplete()"
        (setupError)="onSetupError($event)">
      </zaeper-two-factor-setup>
    </p-card>
  }

  <!-- 2FA Management (when enabled) -->
  @if (!loading && !errorLoading && twoFactorEnabled) {
    <p-card>
      <ng-template pTemplate="header">
        <div class="px-4 pt-4">
          <div class="flex items-center gap-2">
            <i class="pi pi-shield text-green-500"></i>
            <h3 class="text-lg font-semibold m-0">{{ '2fa-title' | zDictionary }}</h3>
          </div>
          <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">{{ '2fa-subtitle-enabled' | zDictionary }}</p>
        </div>
      </ng-template>
      <zaeper-two-factor-manage
        [statusTitle]="labels['2fa-status-title'] || ''"
        [enabledStatusLabel]="labels['2fa-enabled-status'] || ''"
        [disableLabel]="labels['2fa-disable'] || ''"
        [regenerateCodesLabel]="labels['2fa-regenerate-codes'] || ''"
        [disableDialogTitle]="labels['2fa-disable-dialog-title'] || ''"
        [disableDescription]="labels['2fa-disable-description'] || ''"
        [regenerateDialogTitle]="labels['2fa-regenerate-dialog-title'] || ''"
        [regenerateDescription]="labels['2fa-regenerate-description'] || ''"
        [confirmDisableLabel]="labels['2fa-confirm-disable'] || ''"
        [confirmRegenerateLabel]="labels['2fa-confirm-regenerate'] || ''"
        [newRecoveryCodesTitle]="labels['2fa-new-recovery-codes-title'] || ''"
        [copyLabel]="labels['2fa-copy'] || ''"
        [downloadLabel]="labels['2fa-download'] || ''"
        [copiedMessage]="labels['2fa-copied'] || ''"
        [requiredFieldMessage]="labels['2fa-required-field'] || ''"
        [invalidCodeMessage]="labels['2fa-invalid-code'] || ''"
        (disabled)="onDisabled()"
        (codesRegenerated)="onCodesRegenerated($event)">
      </zaeper-two-factor-manage>
    </p-card>
  }
</div>
